export default __webpack_public_path__ + "static/media/0x07738eb4ce8932ca961c815cb12c9d4ab5bd0da4.a61dc656.png";